const InstallAppTabs = {
    ANDROID: 'Android',
    IOS: 'iOS',
    WINDOWS: 'Windows',
    MACOS: 'macOS',
}

export {
    InstallAppTabs
};
